export const PRODUCT_LIST_ENDPOINT = `/ws/api/health/quick-quote/`;
